import LandingPage from "./LandingPage";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import Questions from "./Questions";
import Jobs from "./Jobs";
import Certificates from "./Certificates";

const WelcomePage = () => {
    return (
        <>
            <LandingPage/>
            <AboutUs/>
            <ContactUs/>
            <Jobs/>
            <Questions/>
            <Certificates/>
        </>
    );
}

export default WelcomePage;